import { Log } from '@lightningjs/sdk';
import { Backend } from './Backend';

export class BaseCachedApi {
  protected lastUpdate: number;
  protected cacheExpiration: number;
  protected _cache: unknown;
  private activePromise: Promise<unknown> | undefined;
  protected _bypassCache: boolean | undefined;
  private reloadingCache: boolean;
  private defaultExpiration: number;
  private errorExpiration: number;

  constructor() {
    this.cacheExpiration = 0;
    this.lastUpdate = 0;
    this._cache = undefined;
    this.activePromise = undefined;
    this.reloadingCache = false;
    this.defaultExpiration = 600000;
    this.errorExpiration = 300000;
  }

  protected updateExpirations(defaultExpiration: number, errorExpiration: number) {
    this.defaultExpiration = defaultExpiration;
    this.errorExpiration = errorExpiration;
  }

  checkCache(backend: Backend): Promise<unknown> {
    if (new Date().getTime() > this.lastUpdate + this.cacheExpiration || this._bypassCache) {
      this.bypassCache(false);
      return this.activePromise || this._fillCache(backend);
    } else {
      return Promise.resolve(this._cache);
    }
  }

  bypassCache(val: boolean): void {
    this._bypassCache = val;
  }

  _fillCache(backend: Backend): Promise<unknown> {
    this.activePromise = this.fillCache(backend)
      .then(result => {
        this.lastUpdate = new Date().getTime();
        this.cacheExpiration = this.defaultExpiration;
        return result;
      })
      .catch(error => {
        Log.error('[CachedApi] error filling cache', error);
        this.lastUpdate = new Date().getTime();
        this.cacheExpiration = this.errorExpiration;
        this.reloadingCache = false;
        this.activePromise = undefined;
        throw error;
      })
      .finally(() => {
        this._bypassCache = false;
        this.reloadingCache = false;
        this.activePromise = undefined;
      });
    return this.activePromise;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fillCache(backend: Backend): Promise<unknown> {
    throw new Error('[BaseCachedApi] fillCache not implemented');
  }

  clearCache() {
    if (this.reloadingCache) {
      return;
    }
    this._cache = undefined;
    this.lastUpdate = 0;
    this.cacheExpiration = 0;
    this.reloadingCache = true;
  }
}
